function headerscroll() {
  // select the body element
const body = document.querySelector('body');

// listen for the scroll event
window.addEventListener('scroll', () => {
  // check if the user has scrolled down at least 100 pixels
  if (window.scrollY >= 90) {
    // if so, add the 'scrolled' class to the body element
    body.classList.add('scrolled');
  } else {
    // if not, remove the 'scrolled' class from the body element
    body.classList.remove('scrolled');
  }
});
  
  
}

export default {
    init: function () {
      headerscroll();
    }
};